import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_Pathway = 'Pathway';
export const DomainNamespace_PathwayEditor = 'Pathway Editor';
export const PermissionKey_PathwayView = 'pathway-view';
export const PermissionKey_PathwayEdit = 'permission-key--pathway-edit';
export const PermissionKey_PathwayDelete = 'permission-key--pathway-delete';
export const PathwayCollectionPermissionKeys = {
    view: PermissionKey_PathwayView,
    edit: PermissionKey_PathwayEdit,
    delete: PermissionKey_PathwayDelete
};
export const PathwayEditorPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_PathwayEditor, defaultUIAccessLevels);
//# sourceMappingURL=permissions.js.map